import React, { FC } from 'react';

import ArrowDownAlt from '@ast/magma/components/icon/icons/ArrowDownAlt';
import ArrowUpAlt from '@ast/magma/components/icon/icons/ArrowUpAlt';

import { NumberOrEmpty } from '@app/common/types/Emptible';
import { roundNumber } from '@app/common/utils/roundNumber/roundNumber';

import { useBankAccountsTranslation } from '@app/widgets/bank-accounts/hooks';
import styles from '@app/widgets/bank-accounts/pages/Overview/components/AccountsCard/AccountsCard.pcss';

export enum Sign {
  POSITIVE = 1,
  NEGATIVE = -1,
}

export const AccountTotalUnrealizedPlPercentIcon: FC<{
  value: number
}> = (
  { value },
) => {
  if (Math.sign(value) === Sign.POSITIVE) {
    return (
      <ArrowUpAlt
        data-stable-name="InvestmentPercentIconPositive"
        className={styles.iconGreen}
      />
    );
  }
  if (Math.sign(value) === Sign.NEGATIVE) {
    return (
      <ArrowDownAlt
        data-stable-name="InvestmentPercentIconNegative"
        className={styles.iconNegative}
      />
    );
  }
  return null;
};

export const AccountTotalUnrealizedPlPercent: FC<{
  value: NumberOrEmpty
}> = (
  { value },
) => {
  const { t } = useBankAccountsTranslation();
  const percentValue = value;
  if (percentValue !== null && percentValue !== undefined) {
    const totalLabel = t('investment-performance|Total unrealized Profit/Loss percent label', 'Performance');
    const percentLabel = `${roundNumber(percentValue, 2)}% ${totalLabel}`;
    return (
      <span data-stable-name="InvestmentPercent">
        <AccountTotalUnrealizedPlPercentIcon value={percentValue} />
        {percentLabel}
      </span>
    );
  }
  return null;
};
